"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMenuItemId;
function getMenuItemId(position) {
  return "rbt-menu-item-" + position;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/utils/getMenuItemId.js
// module id = 1308
// module chunks = 0